'use client';

import { useEffect } from 'react';

// 最小限の画像保護制御（本番環境のみ）
const ImageProtection = () => {
  useEffect(() => {
    // 本番環境でのみ動作
    if (process.env.ENV !== 'production') {
      return;
    }
    // 右クリック無効化
    const handleContextMenu = (e: MouseEvent) => {
      e.preventDefault();
      return;
    };

    // キーボード制御
    const handleKeyDown = (e: KeyboardEvent) => {
      /**
       * 開発者ツールのアクセス制御
       */
      // F12
      if (e.key === 'F12') {
        e.preventDefault();
        return;
      }
      // Windows/Linux: Ctrl+Shift+I
      if (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'i')) {
        e.preventDefault();
        return;
      }
      // Mac: Cmd+Option+I
      if (e.metaKey && e.altKey && (e.key === 'I' || e.key === 'i' || e.code === 'KeyI')) {
        e.preventDefault();
        return;
      }
      // Mac: Cmd+Option+C
      if (e.metaKey && e.altKey && (e.key === 'C' || e.key === 'c' || e.code === 'KeyC')) {
        e.preventDefault();
        return;
      }
    };

    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return null;
};

export default ImageProtection;
